import { render, staticRenderFns } from "./ConsultaParecerReferencial.vue?vue&type=template&id=6a871a3b"
import script from "./ConsultaParecerReferencial.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConsultaParecerReferencial.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports